"use client";

import {
	SignedIn,
	SignedOut,
	SignInButton,
	UserButton,
	useUser,
} from "@clerk/nextjs";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Button } from "../ui/button";
import { usePortalTarget } from "@/hooks/use-portal-target";
import { createPortal } from "react-dom";
const AuthNavButtons = () => {
	const pathname = usePathname();
	const { isSignedIn } = useUser();
	const { target, isReady } = usePortalTarget("auth-navbar-buttons");

	if (!isReady) return null;
	return createPortal(
		<>
			{process.env.NEXT_PUBLIC_CLERK_APP_WAITLIST_MODE === "true" ? (
				!isSignedIn ? (
					<Button
						className="hidden sm:inline-flex text-black bg-purple-600 hover:bg-purple-800"
						asChild
					>
						<Link href="/waitlist">Join Waitlist</Link>
					</Button>
				) : (
					<>
						<UserButton />
						<Button
							className="hidden sm:inline-flex text-black bg-purple-600 hover:bg-purple-800"
							asChild
						>
							<Link href="/qb_/overview">Go to Dashboard</Link>
						</Button>
					</>
				)
			) : (
				<>
					<SignedIn>
						<UserButton />
						<Button
							asChild
							className={
								pathname.includes("dashboard")
									? "hidden"
									: "hidden sm:inline-flex text-black bg-purple-600 hover:bg-purple-800"
							}
						>
							<Link href="/qb_/overview">Go to Dashboard</Link>
						</Button>
					</SignedIn>

					<SignedOut>
						<Button
							className="hidden sm:inline-flex text-black bg-purple-600 hover:bg-purple-800"
							asChild
						>
							<SignInButton />
						</Button>
					</SignedOut>
				</>
			)}
		</>,
		target!
	);
};

export default AuthNavButtons;
